import { getCrucibleNftData } from 'api/blockchain/crucibleNft';
import { useWeb3React } from 'hooks/web3';
import { useQuery } from 'react-query';
import { useConfig } from 'store/config';
import { Crucible, ExtendedRewardProgram } from 'types';
import { Queries } from 'types/enum';
import { UsdValues } from 'types/firebase';
import { usePrograms } from './usePrograms';
import { useUsdValues } from './useUsdValues';
import CrucibleData from 'helpers/nft/crucibleData';

export function useCrucibleNftData(crucible: Crucible) {
  const { chainId = 1, provider, account } = useWeb3React();
  const { data: usdValues } = useUsdValues();
  const { data: rewardPrograms } = usePrograms();
  const { config } = useConfig(chainId);

  return useQuery<CrucibleData>(
    [Queries.CRUCIBLE_NFT_DATA, crucible.id, chainId, account],
    () =>
      getCrucibleNftData(
        crucible,
        chainId,
        config,
        provider,
        usdValues as UsdValues,
        rewardPrograms as ExtendedRewardProgram[]
      ),
    {
      enabled: !!crucible && !!usdValues && !!rewardPrograms
    }
  );
}
